const setSlideActive = (state, payload) => {
  if (payload.type === 'multipleChoice') {
    payload.typeChart = payload.typeChart || 'barChart'
  }
  state.slideActive = {
    ...payload,
  }

  // fixing techdebt in progress
  // create another state called activeSlideId
  // hopefully someday can delete staet.slideActive
  // issue: https://ahaslides.atlassian.net/browse/AHA-5613
  // ask Loi Hoang, Huong Nguyen or Linh Vu if you dont understand
  state.activeSlideId = state.slideActive && state.slideActive.id
  state.presentation.slides = state.presentation.slides.map((item) => {
    if (!item.id || item.id !== state.slideActive.id) return item
    return state.slideActive
  })
  if (state.slideActive && state.slideActive.id) {
    state.lastSlideActiveId = state.slideActive.id
  }
}

const checkSlideMovingDirection = (state, currentSlideId) => {
  const previousIndex = state.previousSlideIndex !== null && state.previousSlideIndex !== undefined
    ? state.previousSlideIndex
    : -1
  const currentIndex = state.presentation.slides.findIndex((item) => currentSlideId === item.id)
  state.slideMovingDirection = currentIndex - previousIndex
  state.previousSlideIndex = currentIndex

  if (state.slideMovingDirection < 0 && state.continueQuiz) {
    state.continueQuiz = false
  }
}

export const updateSlideActive = (state, payload) => {
  // some responses from old active slide are comming back when
  // active slide is already changed
  if (payload.slideId && state.slideActive.id !== payload.slideId) return

  state.slideActive = { ...state.slideActive, ...payload }

  // fixing techdebt in progress
  // create another state called activeSlideId
  // hopefully someday can delete staet.slideActive
  // issue: https://ahaslides.atlassian.net/browse/AHA-5613
  // ask Loi Hoang, Huong Nguyen or Linh Vu if you dont understand
  state.activeSlideId = state.slideActive && state.slideActive.id
  state.presentation.slides = state.presentation.slides.map((item) => {
    if (!item.id || item.id !== state.slideActive.id) return item
    return state.slideActive
  })
  if (state.slideActive && state.slideActive.id) {
    state.lastSlideActiveId = state.slideActive.id
  }
}

const updateSlideById = (state, payload) => {
  if (payload.id === state.slideActive.id) {
    state.slideActive = {
      ...state.slideActive,
      ...payload,
    }
  }
  state.presentation.slides = state.presentation.slides.map((item) => {
    if (!item.id || item.id !== payload.id) return item
    return {
      ...item,
      ...payload,
    }
  })
}

const setStartPresentingFromSlideId = (state, payload) => {
  state.startPresentingFromSlideId = payload
}

const setPendingCanvasBlockPayload = (state, payload) => {
  state.pendingCanvasBlockPayload = payload
}

export default {
  updateSlideActive,
  updateSlideById,
  setSlideActive,
  checkSlideMovingDirection,
  setStartPresentingFromSlideId,
  setPendingCanvasBlockPayload,

}
